import React, { Component } from "react";

const MODAL_ID = "modalCreateInvoiceConfirm";

class CreateInvoiceConfirm extends Component {
  forceCleanupModal = () => {
    try {
      window.$("#" + MODAL_ID).modal("hide");
      window.$(".modal-backdrop").remove();
      window.$("body").removeClass("modal-open").css("padding-right", "");
    } catch (e) {}
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      window.$("#" + MODAL_ID).modal({ backdrop: "static", keyboard: false });
      window.$("#" + MODAL_ID).modal("show");
    } else if (prevProps.show && !this.props.show) {
      this.forceCleanupModal();
    }
  }

  componentWillUnmount() {
    this.forceCleanupModal();
  }

  render() {
    if (!this.props.show) return null;
    const {
      title = "Create Invoice?",
      message = "Do you want to create an invoice for this order?",
      orderno,
      onYes,
      onNo,
    } = this.props;

    return (
      <div className="modal fade" tabIndex="-1" id={MODAL_ID}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div
            className="modal-content"
            style={{ borderRadius: 10, overflow: "hidden" }}
          >
            <div className="modal-body modal-body-lg text-center">
              <div className="nk-modal">
                <em
                  className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-file-text bg-info"
                  style={{ color: "#fff" }}
                ></em>
                <h4 className="nk-modal-title" style={{ marginTop: 16 }}>
                  {title}
                </h4>
                <div className="nk-modal-text">
                  <p>{message}</p>
                  {orderno && (
                    <p style={{ fontSize: 12, color: "#6B7280" }}>
                      Order <strong>{orderno}</strong>
                    </p>
                  )}
                </div>
                <div className="nk-modal-action" style={{ marginTop: 20 }}>
                  <button
                    type="button"
                    className="btn btn-lg btn-mw btn-light"
                    onClick={() => onNo && onNo()}
                    style={{ marginRight: 8 }}
                  >
                    No, thanks
                  </button>
                  <button
                    type="button"
                    className="btn btn-lg btn-mw btn-primary"
                    onClick={() => onYes && onYes()}
                    style={{ background: "#101924", borderColor: "#101924" }}
                  >
                    Yes, create invoice
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateInvoiceConfirm;
